import { render, staticRenderFns } from "./AddFood.vue?vue&type=template&id=3dacaafc"
import script from "./AddFood.vue?vue&type=script&lang=js"
export * from "./AddFood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports